<template>
  <div :class="$style.product">
    <div :class="$style.title">
      <!-- <i class="iconfont yw-xiangzuo"></i> -->
      <span>充值中心</span>
      <div :class="$style.record" @click="showRecord">
        <span>充值记录</span>
      </div>
    </div>
    <div :class="$style.wrapper" ref="scroll">
      <div :class="$style.content">
        <div :class="$style.info">
          <div :class="$style.game">
            <img :src="gameIcon" alt="" />
            <div :class="$style.gameInfo">
              <p>{{ game }}</p>
              <p :class="$style.bind" v-if="!hasRoleInfo">请绑定角色</p>
              <p v-if="hasRoleInfo" :class="$style.serverInfo">
                账号：{{ bindRoleInfo.user_name }}
              </p>
              <p v-if="hasRoleInfo" :class="$style.serverInfo">
                <!-- <span>系统：IOS</span> -->
                <span>区服：{{ bindRoleInfo.server_name }}</span>
                <span>角色：{{ bindRoleInfo.role_name }}</span>
                <i class="iconfont yw-shuaxin1" @click="bindAccount"></i>
              </p>
            </div>
          </div>
          <div :class="$style.account" v-if="!hasRoleInfo">
            <!-- <p>账号昵称</p> -->
            <div :class="$style.bindAccount" @click="bindAccount"></div>
          </div>
        </div>
        <div :class="$style.goodsTitle">
          <img :src="`${$cdnUrl}/offlinePay/pay.png`" alt="" v-if="hiddenTab">
          <div :class="$style.tab" v-else>
            <div v-for="item in tabList" :key="item.value" :class="[tabActive === item.value ? $style.active : '']" @click="tabActive = item.value">
              <span :class="[tabActive === item.value ? $style.spanActive : '']">{{ item.label }}</span>
            </div>
          </div>
        </div>
        <ul :class="$style.goods">
          <li
            v-for="(item, index) in goodsList"
            :key="index"
            @click="currentGoods = item"
          >
            <span :class="$style.actBorder" v-if="currentGoods.id === item.id"></span>
            <span :class="$style.actSelect" v-if="currentGoods.id === item.id"></span>
            <span :class="$style.actGift" v-if="!hideRebate"></span>
            <div :class="$style.content">
              <div :class="$style.img">
                <img :src="item.icon" alt="" />
                <span v-if="item.num" :class="$style.num">{{ item.num }}</span>
              </div>
              <p v-if="item.remain">剩余购买次数：{{ item.remain }}</p>
            </div>
            <div :class="$style.minTitle">
              <p>{{ item.name }}</p>
              <p :class="$style.price">￥{{ item.price }}</p>
            </div>
          </li>
          <li :class="$style.largeCharge" @click="largeCharge" v-if="showLargeFlag"></li>
        </ul>
        <p :class="$style.tips" v-if="!hideRebate">
          通过当前渠道购买道具可额外获赠充值金额<span>3%的钻石返利</span>，赠送的钻石会以邮件形式发放
        </p>
        <p :class="$style.tips">
          如遇到其他问题，请尝试<span @click="openCustomer">联系客服</span>
        </p>
        <p v-show="currentGoods.price" :class="$style.selectProduct">
          支付{{ currentGoods.price }}元，可获得商品[{{ currentGoods.name }}]
        </p>
        <div :class="$style.charge" @click="toCharge"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import BScroll from "@better-scroll/core";
import ObserveDOM from "@better-scroll/observe-dom";
import { getPayTypeNew } from "@/api/pay";
import { isWeiXin } from "@/libs/utils";
import offlinePayGame from "@/config/offlinePayGame";

BScroll.use(ObserveDOM);

export default {
  name: "",
  data() {
    return {
      // gameIcon: `${this.$cdnUrl}/offlinePay/icon/1.png`,
      tabActive: "",
      currentGoods: {},
      tabFlag: false
    };
  },
  mounted() {
    this.scrollInit();
    if (isWeiXin()) {
      this.getPayType({ appkey: this.appkey, roleInfo: this.bindRoleInfo });
    }
    this.$nextTick(() => {
      this.tabActive = this.tabList[0].value

    })
  },
  computed: {
    ...mapState({
      goods: (state) => state.offlinePay.goodsList,
      hiddenTab: (state) => state.offlinePay.hiddenTab,
      bindRoleInfo: (state) => state.offlinePay.bindRoleInfo,
      game: (state) => state.offlinePay.game,
      gameIcon: (state) => state.offlinePay.gameIcon,
      appkey: (state) => state.offlinePay.appkey,
      gameFlag: (state) => state.offlinePay.gameFlag,
      showLargeFlag: (state) => state.offlinePay.showLargeFlag,
    }),
    goodsList() {
      if (this.hiddenTab) return this.goods;
      return this.goods[this.tabActive];
    },
    hideRebate() {
      if (!offlinePayGame[this.gameFlag]) return false
      return offlinePayGame[this.gameFlag].hideRebate
    },
    tabList() {
      const list = [
        {
          label: '充值钻石',
          value: 'diamond'
        },
        {
          label: '每日礼包',
          value: 'daily'
        },
        {
          label: '直购礼包',
          value: 'other'
        },
      ]
      if (this.goods.first && this.goods.first.length) {
        list.unshift({
          label: '首充',
          value: 'first'
        })
      }
      return list
    },
    hasRoleInfo() {
      return Object.keys(this.bindRoleInfo).length !== 0;
    },
  },
  watch: {
    goods() {
      // 若无礼包默认显示钻石tab栏
      if ((this.goods && this.goods.length) && (!this.gift || !this.gift.length) && !this.tabFlag) {
        this.tabActive = 'pay';
        this.tabFlag = true;
      }
    }
  },
  methods: {
    ...mapMutations({
      setOfflineState: "offlinePay/setState",
    }),
    ...mapActions({
      getPayType: "offlinePay/getPayType"
    }),
    openCustomer() {
      location.href = "https://h5.hzwxbz3.cn/v2/h5/manualCustomer"
    },
    bindAccount() {
      this.$emit("bindAccount");
    },
    scrollInit() {
      this.bs = new BScroll(this.$refs.scroll, {
        click: true,
        observeDOM: true,
      });
    },
    showRecord() {
      if (!this.hasRoleInfo) {
        this.$emit("bindAccount");
      } else {
        this.setOfflineState({ recordVisible: true });
      }
    },
    toCharge() {
      if (!this.currentGoods.id) {
        this.$toast('请选择商品')
        return;
      }
      this.setOfflineState({
        currentGoods: this.currentGoods,
        chargeVisible: true,
        largeChargeFlag: false
      });
    },
    largeCharge() {
      this.setOfflineState({
        chargeVisible: true,
        largeChargeFlag: true
      });
    }
  },
  components: {},
};
</script>

<style lang="scss" module>
.product {
  height: 100%;
  overflow: hidden;
  font-weight: 400;
  background: linear-gradient(to bottom, #661a1a 0%, #1f0005 35%, #1f0005 100%);
  padding-top: 50px;
  .title {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 17px;
    font-weight: 500;
    color: #ffffff;
    z-index: 5;
    height: 50px;
    padding: 0 12px 0 22px;
    .record {
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      color: #ffffff;
      font-size: 12px;
    }
  }
  .wrapper {
    height: 100%;
    overflow: hidden;
    > .content {
      padding-bottom: 145px;
      > .tips {
        padding: 0 20px;
        font-size: 12px;
        line-height: 14px;
        margin-bottom: 10px;
        color: #ffffff;
        > span {
          color: #FDCE4A;
          font-weight: blod;
        }
      }
      > .selectProduct {
        font-size: 12px;
        color: #FDCE4A;
        padding: 0 20px;
      }
    }
  }
  .info {
    display: flex;
    align-items: center;
    .game {
      position: relative;
      display: flex;
      align-items: center;
      padding: 0 12px;
      width: 80vw;
      flex: 1;
      > img {
        width: 60px;
        height: 60px;
        margin-right: 8px;
        border-radius: 12 px;
      }
      .gameInfo {
        > p:nth-child(1) {
          font-size: 15px;
          color: #ffffff;
          margin-bottom: 10px;
        }
        .bind {
          color: #FDCE4A;
          font-size: 12px;
        }
        .serverInfo {
          color: #ffffff;
          font-size: 10px;
          margin-bottom: 5px;
          > span {
            margin-right: 10px;
          }
          :global {
            .yw-shuaxin1 {
              font-size: 12px;
              vertical-align: text-bottom;
            }
          }
        }
      }
    }
    .account {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 45vw;
      .bindAccount {
        width: 104px;
        height: 35px;
        background: url("//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/bind.png")
          no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        &:active {
          opacity: 0.8;
        }
      }
    }
  }

  .tabTitle {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #bbbbbb;
    > img {
      width: 14px;
      height: 14px;
      margin-right: 6px;
    }
    &.active {
      color: #FDCE4A;
    }
  }
  .goodsTitle {
    margin-top: 10px;
    > img {
      width: 150px;
      height: 27px;
      display: block;
      margin: auto;
    }
    .tab {
      display: flex;
      justify-content: center;
      >div {
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: url("//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/tab.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 80px;
        height: 40px;
        font-size: 13px;
        margin: 0 -5px;
        color: #FFE77D;
        > span {
          text-shadow: 1px 0px  #000000;
        }
      }
      .active {
        background-image: url("//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/tab1.png");
      }
      .spanActive {
        color: #A51306;
        text-shadow: 1px 0px #FBF6BC;
      }
    }
  }
  .goods {
    display: grid;
    grid-template-columns: 33.3% 33.3% 33.3%;
    margin: 9px;
    margin-top: -13px;
    padding: 20px 6px;
    justify-items: center;
    background: url('//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/back.png') no-repeat;
    background-size: 100% 100%;
    > li {
      position: relative;
      justify-items: center;
      width: 109px;
      margin: 4px;
      background: url('//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/back_1.png') no-repeat;
      background-size: 100% 100%;
      padding: 5px;
      .actBorder {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: url('//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/xuanzhong_1.png') no-repeat;
        background-size: 100% 100%;
      }
      .actSelect {
        position: absolute;
        top: -5px;
        right: -5px;
        width: 20px;
        height: 20px;
        background: url('//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/xuanzhong.png') no-repeat;
        background-size: 100% 100%;
      }
      .actGift {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 50px;
        height: 50px;
        background: url('//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/zuanshi.png') no-repeat;
        background-size: 100% 100%; 
      }
      .minTitle {
        font-size: 13px;
        position: relative;
        padding: 10px 0 0 5px;
        .price {
          font-weight: bold;
          color: #0ab102;
          line-height: 20px;
          font-size: 15px;
        }
      }
      .content {
        text-align: center;
        padding-bottom: 5px;
        .img {
          position: relative;
          display: inline-block;
          > img {
            height: 50px;
            max-width: 90%;
            margin: auto;
          }
          .num {
            color: #000000;
            position: absolute;
            font-size: 12px;
            bottom: 5px;
            right: 0px;
          }
        }
        > p {
          margin-top: 10px;
          color: #FDCE4A;
          font-size: 14px;
        }
      }
    }
    .largeCharge {
      background: url('//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/largeCharge.png') no-repeat;
      background-size: 70% 70%;
      background-position:center;
      width: 109px;
      height: 120px;
    }
  }
  .charge {
    width: 175px;
    height: 35px;
    background: url("//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/pay_1.png")
      no-repeat;
    background-size: 100% 100%;
    margin: 22px auto 0;
    &:active {
      opacity: 0.8;
    }
  }
}
</style>